import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Loader } from 'semantic-ui-react';

/**
 * Renders on /auth after Auth0 redirects back. Waits for the SDK to process
 * the callback (code/hash) and set isAuthenticated, then redirects to /.
 * Do NOT redirect from onRedirectCallback — that can clear the URL before
 * the SDK reads the code and breaks login.
 */
const AuthCallbackPage = ({ history }) => {
  const { isLoading, isAuthenticated, error } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      history.replace('/');
    }
  }, [isLoading, isAuthenticated, history]);

  if (error) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Sign-in error</h1>
        <p>{error.message}</p>
        <a href="/">Return to app</a>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <Loader active inline="centered" content="Completing sign in..." />
    </div>
  );
};

export default AuthCallbackPage;
